import axios from "axios";
import {logger} from "./loggingService";

const get = async (lat: number, lon: number): Promise<Timezone> => {
    try {
        const response = await fromIss(lat, lon);
        return {
            id: response.timezone_id,
            offset: response.offset,
        };
    } catch (error) {
        logger.error(error, "couldn't get timezone from wheretheiss, trying to get from google");

        const response = await fromGoogle(lat, lon);
        return {
            id: response.timeZoneId,
            offset: response.rawOffset / 3600,
        };
    }
}

const fromIss = async (lat: number, lon: number): Promise<IisTimezoneResponse> => {
    const response = await axios.get(`${import.meta.env.VITE_TIMEZONE_IIS_API_URL}${lat},${lon}`);
    return response.data;
}

const fromGoogle = async (lat: number, lon: number): Promise<GoogleTimezoneResponse> => {
    const timestamp = Math.floor(Date.now() / 1000);
    const response = await axios.get(`${import.meta.env.VITE_TIMEZONE_GOOGLE_API_URL}&location=${lat},${lon}&timestamp=${timestamp}`);
    return response.data;
}

const timezoneService = {
    get,
}

export default timezoneService;